import LayoutWrapper from "../../layout";

const ProtectedLayout = ({children}) => (
    <LayoutWrapper>
        {children}
    </LayoutWrapper>
);

export default ProtectedLayout;